var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./button.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-38167ed1!../../../../vue-loader/lib/selector?type=template&index=0!./button.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/packages/button/src/button.vue
// module id = 148
// module chunks = 2